export const FIDO_AUTHENTICATION = 'FIDO AUTHENTICATION';
export const SUCCESSFULL_FIDO_AUTHENTICATION = 'FIDO_AUTHENTICATION_SUCCESS';
export const FIDO_AUTH_FAIL = 'FIDO_AUTHENTICATION_FAILURE';
export const FIDO_REG_SUCCESS = 'FIDO_REGISTRATION_SUCCESS';
export const FIDO_REG_FAIL = 'FIDO_REGISTRATION_FAILURE';
export const REMIND_ME_ACTION = 'REMIND_ME_LATER';
export const SWITCH_TO_PWD_ACTION = 'SWITCH_TO_PASSWORD';
export const EMAIL_AUTHENTICATOR_PICKED = 'EMAIL_AUTHENTICATOR_PICKED';
export const MOBILE_AUTHENTICATOR_PICKED = 'MOBILE_AUTHENTICATOR_PICKED';
export const PUSH_AUTHENTICATOR_PICKED = 'PUSH_AUTHENTICATOR_PICKED';
export const GET_ADP_MOBILE_APP = 'GET_ADP_MOBILE_APP';
export const CANCEL_SELECTED = 'CANCEL_SELECTED';
export const BACK_SELECTED = 'BACK_SELECTED';
export const OTP_VERIFICATION_SUCCESS = 'OTP_VERIFICATION_SUCCESS';
export const OTP_VERIFICATION_FAILURE = 'OTP_VERIFICATION_FAILURE';
export const PUSH_OPTION_SHOWN = 'PUSH_OPTION_SHOWN';
export const ADDITIONAL_OPTIONS_SELECTED = 'ADDITIONAL_OPTIONS_SELECTED';
export const PUSH_SUCCESSFUL = 'PUSH_SUCCESSFUL';
export const PUSH_FAILED = 'PUSH_FAILED';
export const PUSH_DENIED = 'PUSH_DENIED';
export const PUSH_TIMEDOUT = 'PUSH_TIMEDOUT';
export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';
export const DENIED = 'DENIED';
export const LOCKED = 'LOCKED';
